export const TaskNames = {
  SPLITTER: 'splitter',
  MERGER: 'merger',
  CONVERTER: 'converter',
  RECOGNIZER: 'recognizer',
  CLASSIFIER: 'classifier',
  EXTRACTOR: 'extractor',
  PAGE_COUNTER: 'page-counter',
  IMPORT: 'import-from-encompass',
  IMPORT_COUNTER: 'import-from-encompass-counter',
  EXPORT: 'export-to-encompass',
  CREATE_SUBSCRIPTION: 'create-encompass-subscription',
  DELETE_SUBSCRIPTION: 'delete-encompass-subscription',
  IMPORT_FIELD_VALUES_FROM_ENCOMPASS: 'import-field-values-from-encompoass',
  DOCUMENT_CHANGE_HANDLER: 'document-change-handler',
};

export const TaskStatus = {
  queued: 0,
  running: 50,
  failed: 0,
  completed: 100,
};

export const THRESHOLD_CONFIDENCE = 90;
